import { useEffect, useRef, useState } from 'react';
import { IAgenda, IAppointment, IDepartment } from '../constants/types';
import {
    applyAppointmentFormPrefill,
    AppointmentPrefillApplication,
    AppointmentPrefillWarning,
} from '../utils/appointmentPrefill';

export function useAppointmentFormPrefill(
    prefillTemplate: IAppointment | null | undefined,
    agendas: IAgenda[],
    departmentsWithAgenda: IDepartment[],
    mode: 'make' | 'consult',
): {
    prefillWarnings: AppointmentPrefillWarning[];
    prefillBootstrap: AppointmentPrefillApplication | null;
} {
    const appliedRef = useRef(false);
    const [prefillWarnings, setPrefillWarnings] = useState<AppointmentPrefillWarning[]>([]);
    const [prefillBootstrap, setPrefillBootstrap] = useState<AppointmentPrefillApplication | null>(null);

    useEffect(() => {
        if (!prefillTemplate || appliedRef.current || mode !== 'make' || agendas.length === 0) {
            return;
        }

        appliedRef.current = true;
        const bootstrap = applyAppointmentFormPrefill(prefillTemplate, agendas, departmentsWithAgenda);
        setPrefillWarnings(bootstrap.warnings);
        setPrefillBootstrap(bootstrap);
    }, [prefillTemplate, agendas, departmentsWithAgenda, mode]);

    return { prefillWarnings, prefillBootstrap };
}
